import React, { useContext, useState } from "react";
import { Popover, Table } from "antd";
import { EducacionNoFormal } from "../../../../models/JuradosModel/jurados.model";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { ModalNoFormal } from "./modal-noformal.view";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { ModalEliminarExperiencia } from "./ModalEliminar";
import { TemplateContext } from "../../../../utils/template_context";

type TableNoFormalProps = {
  eduacionFormalArray: EducacionNoFormal[];
  setEduacionFormalArray: Function;
};
export const TableNoFormal = ({
  eduacionFormalArray,
  setEduacionFormalArray,
}: TableNoFormalProps) => {
  const context = useContext(TemplateContext);

  const [openModal, setOpenModal] = useState(false);
  const [datosSelected, setDatosSelected] =
    useState<EducacionNoFormal>(initialValues);
  const [indexDatosSelected, setIndexDatosSelected] = useState(0);

  const columns: any = [
    {
      title: "No.",
      key: "index",
      fixed: context.device === "md" ? "left" : false,
      width: 60,
      render: (datos: EducacionNoFormal, record: any, index: number) => (
        <div>{index + 1}</div>
      ),
    },
    {
      title: "Nombre de educación",
      key: "nombre_educacion",
      fixed: context.device === "md" ? "left" : false,
      //   width: 150,
      dataIndex: "nombre_educacion",
      render: (data) => {
        return data.length > 27 ? (
          <Popover content={data} title="Nombre de educación">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${data.substring(0, 26)}...`}</span>
          </Popover>
        ) : (
          data
        );
      },
    },
    {
      title: "Nombre del Proceso",
      key: "nombre_proceso",
      dataIndex: "nombre_proceso",
      //   width: 150,
      render: (data) => {
        return data.length > 27 ? (
          <Popover content={data} title="Nombre del proceso">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${data.substring(0, 26)}...`}</span>
          </Popover>
        ) : (
          data
        );
      },
    },
    {
      title: "Institución",
      key: "institucion",
      dataIndex: "institucion",
      //   width: 100,
      render: (data: string, record: any, index: number) => {
        if (!data) return <div>N/A</div>;
        if (data.length > 27) return (
          <Popover content={data} title="Institución">
            <span style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}>{`${data.substring(0, 26)}...`}</span>
          </Popover>
        );
        return <>{data}</>;
      },
    },
    {
      title: "Fecha Inicio",
      key: "fecha_inicio",
      dataIndex: "fecha_inicio",
      //   width: 100,
    },
    {
      title: "Fecha terminación",
      key: "fecha_terminacion",
      dataIndex: "fecha_terminacion",
      //   width: 150,
    },
    {
      title: "No. de horas",
      key: "numero_horas",
      dataIndex: "numero_horas",
      width: 120,
    },
    {
      title: "Ciudad",
      key: "ciudad",
      dataIndex: "ciudad",
      //   width: 150,
      render: (data) => {
        return data.length > 27 ? (
          <Popover content={data} title="Ciudad">
            <span
              style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
            >{`${data.substring(0, 26)}...`}</span>
          </Popover>
        ) : (
          data
        );
      },
    },
    {
      title: (
        <div>
          <div className="titleAcciones">Acciones</div>
          <div className="controls mt-2">
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Ver
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Editar
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Borrar
            </div>
          </div>
        </div>
      ),
      key: "actions",
      width: 150,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: EducacionNoFormal, record: any, index: number) => (
        <div className="controls">
          <EyeOutlined
            onClick={() => {
              if (datos.path_anexo !== "") {
                setDocumentoVisualizar(datos.path_anexo);
                setModalDocumento(true);
              }
            }}
          />
          <EditOutlined onClick={() => showModal(datos, index)} />
          <DeleteOutlined
            className="color-delete"
            onClick={() => {
              setIndexDatosSelected(index);
              setIndexExperiencia(index);
              setTitulo(datos.nombre_educacion);
              return setModaleliminar(true);
            }}
          />
        </div>
      ),
    },
  ];

  

  const showModal = (datos: EducacionNoFormal, index: number) => {
    setOpenModal(true);
    setDatosSelected(datos);
    setIndexDatosSelected(index);
  };

  const deleteEduacion = (index: any) => {
    let newArray = eduacionFormalArray.filter(
      (x: any, idx: number) => idx !== index
    );
    setEduacionFormalArray(newArray);
  };

  const eliminarFila = (indexdoc: number) => {
    let infoupdate = [...eduacionFormalArray];
    infoupdate = infoupdate.filter((data: any, i: number) => i !== indexdoc);
    setEduacionFormalArray(infoupdate);
    deleteEduacion(indexdoc);
    return setModaleliminar(false);
  };

  const [modalDocumento, setModalDocumento] = useState(false);
  const [modaleliminar, setModaleliminar] = useState(false);
  const [documentoVisualizar, setDocumentoVisualizar] = useState("");
  const [indexExperiencia, setIndexExperiencia] = useState(0);
  const [titulo, setTitulo] = useState("");

  return (
    <>
      <Table
        columns={columns}
        pagination={false}
        dataSource={eduacionFormalArray}
        scroll={{ x: 1500, y: 300 }}
        className="border-top row-shadow mb-3"
        title={() => "Mi lista de educación no formal"}
      />

      <ModalVisualizarDocumentos
        state={{ documento: documentoVisualizar }}
        visualizar={modalDocumento}
        setVisualizar={setModalDocumento}
        tipo="participante"
      />

      <ModalNoFormal
        openModal={openModal}
        setOpenModal={setOpenModal}
        datosSelected={datosSelected}
        setDatosSelected={setDatosSelected}
        eduacionFormalArray={eduacionFormalArray}
        indexDatosSelected={indexDatosSelected}
        setEduacionFormalArray={setEduacionFormalArray}
      />

      {/* <ModalEliminar /> */}
      <ModalEliminarExperiencia
        modal={modaleliminar}
        nombre={titulo}
        eliminar={() => eliminarFila(indexExperiencia)}
        cancelar={() => setModaleliminar(false)}
        indexExperiencia={indexExperiencia}
      />
    </>
  );
};

const initialValues = {
  nombre_educacion: "",
  nombre_proceso: "",
  duracion: "",
  institucion: "",
  fecha_inicio: "",
  fecha_inicio_dia: "",
  fecha_inicio_mes: "",
  fecha_inicio_año: "",
  fecha_terminacion: "",
  fecha_terminacion_dia: "",
  fecha_terminacion_mes: "",
  fecha_terminacion_año: "",
  numero_horas: "",
  ciudad: "",
  path_anexo: "",
};
